module.exports = __webpack_public_path__ + "img/logo-es.508a8daa5c99355f07399cbc874a38db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-es.svg
// module id = 706
// module chunks = 0